import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { formatOrganizationForDropdown, formatTeamForMultiSelectDropdown } from '../../../utils/filter.util';
import { useGetOrganizations } from '../../../hooks/organization/organization.hook';
import { useGetTeamsByOrganizationId } from '../../../hooks/team/team.hook';
import { MultiSelectDropdown } from '../../../shared/components/MultiSelectDropdown/MultiSelectDropdown';
import { getDateStrFromDateObj } from '../../../common/utils/date.util';
import { sortObjectArrayByStringField } from '../../../common/utils/utils';

export function UserListFilters({ filters, onApplyFilters }) {
    const [organizationFilterOptions, setOrganizationFilterOptions] = useState([]);
    const [teamFilterOptions, setTeamFilterOptions] = useState([]);
    const [selectedOrganizationId, setSelectedOrganizationId] = useState(filters.organizationId);
    const [selectedTeamIds, setSelectedTeamIds] = useState(filters.teamIds);
    const [selectedNullField, setSelectedNullField] = useState(filters.nullField);
    const [selectedDateFilterType, setSelectedDateFilterType] = useState(filters.dateFilterType);
    const [dateRangeStart, setDateRangeStart] = useState(() => {
        if (filters.dateRangeStart) {
            return new Date(filters.dateRangeStart);
        }

        const currentDate = new Date();
        currentDate.setMonth(currentDate.getMonth() - 1);
        return currentDate;
    });
    const [dateRangeEnd, setDateRangeEnd] = useState(() => {
        if (filters.dateRangeEnd) {
            return new Date(filters.dateRangeEnd);
        }

        const currentDate = new Date();
        return currentDate;
    });

    const { data: organizationsData } = useGetOrganizations();
    const { data: teamsData } = useGetTeamsByOrganizationId(selectedOrganizationId);

    useEffect(() => {
        if (organizationsData?.results) {
            const organizationFilterOptionsData = organizationsData?.results?.map((organization) => formatOrganizationForDropdown(organization));
            sortObjectArrayByStringField(organizationFilterOptionsData, 'label');
            setOrganizationFilterOptions(organizationFilterOptionsData);
        }
    }, [organizationsData]);

    useEffect(() => {
        if (teamsData?.results) {
            const teamFilterOptionsData = teamsData?.results?.map((team) => formatTeamForMultiSelectDropdown(team));
            setTeamFilterOptions(teamFilterOptionsData);
        }
    }, [teamsData]);

    function onApplyClick() {
        onApplyFilters({
            ...filters,
            organizationId: selectedOrganizationId,
            teamIds: selectedTeamIds,
            nullField: selectedNullField,
            dateFilterType: selectedDateFilterType,
            dateRangeStart: selectedDateFilterType === "range" ? getDateStrFromDateObj(dateRangeStart) : '',
            dateRangeEnd: selectedDateFilterType === "range" ? getDateStrFromDateObj(dateRangeEnd) : '',
        });
    }

    return (
        <div>
            <div className="mb-2">
                <select
                    className="form-select cstm-category"
                    placeholder='Filter organization'
                    value={selectedOrganizationId}
                    onChange={(e) => {
                        setSelectedOrganizationId(e.target.value);
                        setTeamFilterOptions([]);
                        setSelectedTeamIds([]);
                    }}
                >
                    <option value="">All Organizations</option>

                    {organizationFilterOptions.map((organization) => (
                        <option key={organization.value} value={organization.value}>{organization.label}</option>
                    ))}
                </select>
            </div>
            <div className="mb-2">
                <MultiSelectDropdown
                    label="Teams"
                    items={teamFilterOptions}
                    selectedIds={selectedTeamIds}
                    disabled={!selectedOrganizationId}
                    onChange={(selectedIds) => {
                        setSelectedTeamIds(selectedIds);
                    }}
                />
            </div>
            <div className='mb-2'>
                <select
                    className="form-select cstm-category"
                    value={selectedNullField}
                    onChange={(e) => setSelectedNullField(e.target.value)}
                >
                    <option value="" disabled>Null Fields</option>
                    <option value="">No filter</option>
                    <option value="image">Image</option>
                    <option value="occupation">Job Title</option>
                    <option value="teams">Teams</option>
                </select>
            </div>

            <div className='mb-2'>
                <select
                    className="form-select cstm-category"
                    value={selectedDateFilterType}
                    onChange={(e) => setSelectedDateFilterType(e.target.value)}
                >
                    <option value="">All Time</option>
                    <option value="range">Date Range</option>
                </select>
            </div>

            <div className='d-flex mb-2'>
                <div className='w-50 mr-1'>
                    <DatePicker
                        selected={dateRangeStart}
                        onChange={(date) => setDateRangeStart(date)}
                        dateFormat="MM/dd/yyyy"
                        wrapperClassName="cstm-datepicker"
                        disabled={selectedDateFilterType !== "range"}
                    />
                </div>
                <div className='w-50 ml-1'>
                    <DatePicker
                        selected={dateRangeEnd}
                        onChange={(date) => setDateRangeEnd(date)}
                        dateFormat="MM/dd/yyyy"
                        wrapperClassName="cstm-datepicker"
                        disabled={selectedDateFilterType !== "range"}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-end mt-2">
                <button type='button' className='cstm-submitbutton' onClick={onApplyClick}>Apply</button>
            </div>
        </div>
    );
}
